import {NOTIFICA_ERRORE} from './costanti'

export const localizeMixin = {
    methods: {
        localizza() {
            if ('geolocation' in navigator) {
                /* la geolocalizzazione è disponibile */
                navigator.geolocation.getCurrentPosition((position) => {
                    this.SET_NUOVE_COORDINATE([position.coords.longitude, position.coords.latitude])
                }, () => {
                    // errore
                    this.showNotification({
                        name: NOTIFICA_ERRORE,
                        title: `Impossibile prendere la posizione corrente`
                    })
                })
            } else {
                /* la geolocalizzazione NON È disponibile */
                this.showNotification({
                    name: NOTIFICA_ERRORE,
                    title: `Impossibile prendere la posizione corrente`
                })
            }
        }
    }
}
